<template>
  <footer class="footer has-cards">
    <div class="container">
      <div class="row row-grid align-items-center mb-3">
        <div
          class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12 footer-section-one"
        >
          <h5>درباره سرمد</h5>
          <p>
            شرکت خدمات تجارت سرمد مفتخر است تمامی نیازهای یک مجموعه کسب‌وکار را
            به‌صورت مستقل، مشاوره، خدمت خارج از مکان و اجزای مشترک به نحوی
            برآورده کند که شما به عنوان صاحب ایده یا راه‌انداز یک کسب‌وکار، تنها
            نیاز داشته باشید تمرکز خود را روی اصل ایده و مزیت رقابتی خود متمرکز
            کنید. سرمد به شما کمک می‌کند فکر اولیه خود را به ابده‌های عملیاتی و
            تجاری، ایده را به اجرا و سیستم در حال اجرا را به سود تبدیل کنید.
          </p>
        </div>
        <div
          class="col-xl-5 col-lg-5 col-md-12 col-sm-12 col-12 footer-section-one"
        >
          <h5>ارتباط با ما</h5>

          <div class="items-about-us">
            <div class="about-us-title">
              <i class="fa fa-phone" aria-hidden="true"></i>
            </div>
            <span>
              <a
                href="tel:02166538662"
                style="color: inherit; text-decoration: none;"
              >
                02166538662
              </a></span
            >
          </div>

          <div class="items-about-us">
            <div class="about-us-title">
              <i class="fa fa-map-marker" aria-hidden="true"></i>
            </div>
            <span>
              تهران، شهرآرا، خيابان ستارخان، مجتمع برج‌های ستارخان، برج 1، طبقه
              همکف، واحد 11
            </span>
          </div>
        </div>
        <div
          class="col-xl-3 col-lg-3 col-md-12 col-sm-12 col-xs-12 footer-section-two"
        >
          <div class="logo-footer">
            <img src="img/logo/Sarmad-01.png" alt="logo" />
          </div>
          <h5 class="mt-3">
            سرمد را در شبکه های اجتماعی دنبال کنید
          </h5>
          <div class="d-flex">
            <a
              target="_blank"
              rel="noopener"
              href="https://www.instagram.com/sarmadbs/"
              class="icon-btn-footer"
              data-toggle="tooltip"
              data-original-title="Follow us"
            >
              <i class="fa fa-instagram"></i>
            </a>
            <a
              target="_blank"
              rel="noopener"
              href="https://www.linkedin.com/company/sarmad-business-services/"
              class="icon-btn-footer"
              data-toggle="tooltip"
              data-original-title="Follow us"
            >
              <i class="fa fa-linkedin-square"></i>
            </a>
            <a
              target="_blank"
              rel="noopener"
              href="mailto:info@sarmadbs.com"
              class="icon-btn-footer"
              data-toggle="tooltip"
              data-original-title="Email us"
            >
              <i class="fa fa-envelope-o"></i>
            </a>
            <!-- <a
              target="_blank"
              rel="noopener"
              href="https://www.facebook.com/creativetim"
              class="icon-btn-footer"
              data-toggle="tooltip"
              data-original-title="Like us"
            >
              <i class="fa fa-whatsapp"></i>
            </a> -->
            <!-- <a
              target="_blank"
              rel="noopener"
              href="https://dribbble.com/creativetim"
              class="icon-btn-footer"
              data-toggle="tooltip"
              data-original-title="Follow us"
            >
              <i class="ni ni-send"></i>
            </a> -->
          </div>
        </div>
      </div>
      <hr class="line-Footer" />
      <div class="row align-items-center justify-content-between">
        <div class="col-12 col-xl-4 col-ld-4 col-md-4 col-sm-12 py-0">
          <div class="item-copyright-landing">
            <span>کلیه حقوق این سایت متعلق به شرکت خدمات تجارت سرمد است.</span>
          </div>
        </div>
        <!-- <div class="col-12 col-xl-4 col-ld-4 col-md-4 col-sm-12">
          <div class="item-copyright-landing py-2">
            <span> نسخه </span>
            <a>1.1.0 </a>
          </div>
        </div> -->
        <div class="col-12 col-xl-4 col-ld-4 col-md-4 col-sm-12 py-0">
          <div class="copyright-landing">
            <span> هرگونه کپی برداری پیگرد قانونی دارد </span>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  name: "app-footer",
  data() {
    return {
      year: new Date().getFullYear(),
    };
  },
  methods: {
    gotoapp() {
      window.location.href = "https://marokapp.ir";
    },
  },
};
</script>
<style lang="scss">
.footer-section-one {
  h5,
  h3 {
    font-size: 16px;
    color: #f0a500;
    margin-top: 20px !important;
  }
  p {
    font-size: 13px;
    color: #707070;
  }
}

.footer-section-two {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  h5 {
    font-size: 16px;
    color: #f0a500;
    margin-top: 20px !important;
  }
}

.copyright-landing {
  display: flex;
  align-items: center;
  justify-content: flex-end;

  @media (max-width: 768px) {
    justify-content: center;
  }

  span,
  a {
    font-size: 14px;
    color: #707070;
  }

  a {
    color: #f0a500 !important;
  }
}

.item-copyright-landing {
  display: flex;
  align-items: center;
  justify-content: center !important;

  span,
  a {
    font-size: 14px;
    color: #707070;
  }

  a {
    color: #f0a500 !important;
  }
}

.line-Footer {
  margin-top: 0 !important;
  margin-bottom: 15px !important;
}

.icon-btn-footer {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #f0a500;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 5px;
  cursor: pointer;

  i {
    font-size: 18px;
  }

  &:hover {
    background: #fff;
    color: #f0a500;
    border: 1px solid #f0a500;
  }
}
.logo-footer {
  width: 50px;
  height: 70px;
  img {
    width: 100%;
    height: 100%;
  }
}
</style>
